export enum LoadingState {
  INIT,
  INITIAL_LOADING,
  PAGE_LOADING,
  INFINITE_LOADING,
  ALL_DATA_LOADED,
  SUSPENDED,
  ACCESS_DENIED,
  LOADING_ERROR
}
